import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(private service : AuthService) { }

  ngOnInit(): void {
  }

  forgotPassword(email){
    this.service.ForgotPassword(email);
  }

}
